module.exports = __webpack_public_path__ + "img/evx.f13e8763.svg";